import React from 'react'
import useStyles from './Styles'
import Image from 'next/image'
import { Grid, Typography } from '@mui/material'
import Emoji from 'src/assets/svgs/campaigns/emojiHug.svg'
import RoundedTextField from 'src/components/shared/atoms/roundInputField_v3'
import { ButtonComponent } from 'src/components/shared/atoms'
import TextArea from 'src/components/shared/atoms/textAreaField'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useSnackbar } from 'notistack'
import { usePostFormDataMutation } from 'src/store/ApiCall/formAPI'
import { ContactFormI } from 'src/types/store'
import { getCookie } from 'cookies-next'

interface IProps {
  content: ContactFormI
}
function Collabrations({ content }: IProps) {
  const { classes } = useStyles()
  const { enqueueSnackbar } = useSnackbar()
  const [postFormData] = usePostFormDataMutation()
  const lang = getCookie('lang')

  async function postData(data: {
    data: {
      email: string
      name: string
      phonenumber: string
      subject: string
      message: string
      request_type: string
    }
  }) {
    return await postFormData(data).unwrap()
  }
  const validationSchema = yup.object({
    name: yup
      .string()
      .required(lang === 'En' ? 'name is required' : 'Se requiere el nombre'),
    email: yup
      .string()
      .email()
      .required(
        lang === 'En' ? 'email is required' : 'correo electronico es requerido'
      ),
    phonenumber: yup.string(),
    subject: yup
      .string()
      .required(
        lang === 'En' ? 'subject is required' : 'el tema es obligatorio'
      ),
    message: yup
      .string()
      .required(lang === 'En' ? 'message is required' : 'se requiere mensaje'),
  })

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      phonenumber: '',
      subject: '',
      message: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      if (!values.name || !values.name) {
        enqueueSnackbar('Please add required information', {
          variant: 'error',
        })
        return
      }
      const data = await postData({
        data: {
          ...values,
          request_type: 'brand_collabs',
        },
      })
      if (data && data.data.id) {
        resetForm()
        enqueueSnackbar('Form Submitted Successfully', {
          variant: 'success',
        })
      }
    },
  })
  return (
    <div id="collaborate_form" className={classes.root}>
      <Image src={Emoji} alt="_emoji" />
      <Typography className={classes.title}>{content.heading}</Typography>
      <Typography
        className={classes.desc}
        sx={{ display: { md: 'block', sm: 'none', xs: 'none' } }}
      >
        {content.description}
      </Typography>
      <Typography
        className={classes.desc}
        sx={{ display: { md: 'none', sm: 'block', xs: 'block' } }}
      >
        {content.description}
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <Grid container columnSpacing={{ lg: 8, md: 8, sm: 6, xs: 0 }}>
          <Grid item md={6} sm={12} xs={12}>
            {' '}
            <RoundedTextField
              value={formik.values.name}
              name="name"
              onChangeHandler={formik.handleChange}
              label={content.yourNamePlaceholder}
              error={formik.touched.name ? Boolean(formik.errors.name) : false}
              helperText={formik.touched.name ? formik.errors.name : ''}
            />
          </Grid>
          <Grid item md={6} sm={12} xs={12}>
            {' '}
            <RoundedTextField
              value={formik.values.email}
              name="email"
              label={content.yourEmailPlaceholder}
              onChangeHandler={formik.handleChange}
              error={
                formik.touched.email ? Boolean(formik.errors.email) : false
              }
              helperText={formik.touched.email ? formik.errors.email : ''}
            />
          </Grid>
          <Grid item md={6} sm={12} xs={12}>
            {' '}
            <RoundedTextField
              value={formik.values.phonenumber}
              name="phonenumber"
              onChangeHandler={formik.handleChange}
              error={
                formik.touched.phonenumber
                  ? Boolean(formik.errors.phonenumber)
                  : false
              }
              helperText={
                formik.touched.phonenumber ? formik.errors.phonenumber : ''
              }
              label={content.phoneNumberPlaceholder}
            />
          </Grid>
          <Grid item md={6} sm={12} xs={12}>
            {' '}
            <RoundedTextField
              value={formik.values.subject}
              name="subject"
              onChangeHandler={formik.handleChange}
              error={
                formik.touched.subject ? Boolean(formik.errors.subject) : false
              }
              helperText={formik.touched.subject ? formik.errors.subject : ''}
              label={content.subjectPlaceholder}
            />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            {' '}
            <TextArea
              value={formik.values.message}
              name="message"
              onChangeHandler={formik.handleChange}
              error={
                formik.touched.message ? Boolean(formik.errors.message) : false
              }
              placeholder={content.messagePlaceholder}
              minRows={10}
              helperText={formik.touched.message ? formik.errors.message : ''}
            />
          </Grid>
        </Grid>
        <div className={classes.btnContainer}>
          <ButtonComponent
            type="contained"
            text={content.button.content}
            className={classes.recommendBtn}
            wrapperClass={classes.wrapperClass}
            gradient
            isSubmitBtn
          />
        </div>
      </form>
    </div>
  )
}

export default Collabrations
